var React = require('react');

function ArrowRightNormal (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-4.5 -4.293)"},[React.createElement("line",{"data-name":"Ligne 18","x2":"14","transform":"translate(5 12)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":0}),React.createElement("path",{"data-name":"Tracé 20","d":"M12,5l7,7-7,7","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":1})]));
}

ArrowRightNormal.defaultProps = {"width":"15","height":"15.414","viewBox":"0 0 15 15.414"};

module.exports = ArrowRightNormal;

ArrowRightNormal.default = ArrowRightNormal;
